import React, { Fragment } from 'react'
import { Dialog, Transition } from '@headlessui/react'
import { DangerIcon } from '../../Assets/AllSvg'
import { MdRefresh } from "react-icons/md"

const AddSecurityKeyModal = ({ addKey, setAddKey }) => {
    return (
        <div>
            <Transition.Root show={addKey} as={Fragment}>
                <Dialog as="div" className="relative z-10" onClose={setAddKey}>
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <div className="fixed inset-0 bg-[#c1c9d2b3]" />
                    </Transition.Child>

                    <div className="fixed inset-0 z-10 overflow-y-auto">
                        <div className="flex min-h-full justify-center p-4 text-center items-center sm:p-0">
                            <Transition.Child
                                as={Fragment}
                                enter="ease-out duration-300"
                                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                                enterTo="opacity-100 translate-y-0 sm:scale-100"
                                leave="ease-in duration-200"
                                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                            >
                                <Dialog.Panel className="relative transform overflow-visible rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 w-full max-w-md">
                                    <div>
                                        <div className="font-semibold p-[16px_20px] border-b-[1px] border-[#ebeef1] text-base text-gray-900">Add security key</div>
                                        <div className="p-[49px_20px] flex flex-col gap-3 items-center border-b-[1px] border-[#ebeef1] bg-[#f6f8fa]">
                                            <DangerIcon className="fill-[#87909f] h-[32px] w-[32px]" />
                                            <span className='text-sm text-[#687385] font-medium'>The operation timed out or was cancelled.</span>
                                            <button className="input_focus_shadow text-[13px] rounded-md flex items-center font-medium w-max gap-2 h-[26px] pl-2 pr-3 py-2 justify-center text-[#404552]"><MdRefresh className='text-[18px]' />Try again</button>
                                        </div>
                                        <div className="font-semibold p-[16px_20px] flex justify-end text-base text-gray-900 gap-1">
                                            <button onClick={() => setAddKey(false)} className="h-[30px] rounded-[6px] input_focus_shadow text-[14px] font-semibold p-[0_8px]">Cancel</button>
                                        </div>
                                    </div>
                                </Dialog.Panel>
                            </Transition.Child>
                        </div>
                    </div>
                </Dialog>
            </Transition.Root>
        </div>
    )
}

export default AddSecurityKeyModal